import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@mui/material/Tooltip';
import {AiOutlineFilePdf} from 'react-icons/ai';

let DescargarAPEButton = (props) => {
    return (
        <Tooltip title="Descargar APE">
            <IconButton
                aria-label="Add"
                onClick={() => props.onClick()}
            >
                <AiOutlineFilePdf />
            </IconButton>
        </Tooltip>
    );
}

export default DescargarAPEButton;

  

